import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block, Heading } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import InfoItem from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/InfoItem.react'
import {
  AetOrdererUiForm,
  AetSignerUiForm,
} from 'todistukset-common/src/vtj/types/form-types.type'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'

type Form = AetOrdererUiForm | AetSignerUiForm

type AetSummaryContactInfoProps = Pick<Form, 'contactInfo'>

const AetSummaryContactInfo: React.FC<AetSummaryContactInfoProps> = observer(
  ({ contactInfo: { phoneNumber, email } }) => {
    const { t } = useTranslation()
    return (
      <Block variant="section">
        <Heading variant="h3">
          <LocalizedString stringKey="aetSummaryContactInfoTitle" />
        </Heading>
        <InfoItem
          title={t('aetSummaryContactInfoPhoneNumberLabel')}
          content={finalEditableFieldValue(phoneNumber) || '-'}
        />
        <InfoItem
          title={t('aetSummaryContactInfoEmailLabel')}
          content={finalEditableFieldValue(email) || '-'}
        />
      </Block>
    )
  }
)

export default AetSummaryContactInfo
